export enum TabType {
  return = 'return',
  cancel = 'cancel',
}

export enum FilterIdType {
  returnId = 'returnId',
  orderId = 'orderId',
  returnTrackingNumber = 'returnTrackingNumber',
  itemName = 'itemName',
  skuName = 'skuName',
  sellerSku = 'sellerSku',
  buyerNick = 'buyerNick',
}

export const lazadaServiceLinkMap: Record<string, string> = {
  // id: 'https://psc-alimebot.lazada.co.id/intl/index.htm?_lang=en_ID&from=4pn5phnyvl&spm=a2a14.helpcenter-psc.chat.0',
  // my: 'https://psc-alimebot.lazada.com.my/intl/index.htm?_lang=en_MY&from=UIUObL7s87&spm=a2a16.helpcenter-psc.chat.0',
  // sg: 'https://sellercenter.lazada.sg',
  // th: 'https://psc-alimebot.lazada.co.th/intl/index.htm?_lang=zh_CN&from=wT4m1w12bL&spm=a2a13.helpcenter-psc.chat.0',
  // vn: 'https://sellercenter.lazada.vn',
  // ph: 'https://psc-alimebot.lazada.com.ph/intl/index.htm?_lang=zh_CN&from=IE4iZiFOby&spm=a2a15.helpcenter-psc.chat.0',
  id: 'https://sellercenter.lazada.co.id/seller/helpcenter',
  my: 'https://sellercenter.lazada.com.my/seller/helpcenter',
  sg: 'https://sellercenter.lazada.sg/seller/helpcenter',
  th: 'https://sellercenter.lazada.co.th/seller/helpcenter',
  vn: 'https://sellercenter.lazada.vn/seller/helpcenter',
  ph: 'https://sellercenter.lazada.com.ph/seller/helpcenter',
  cnsc: 'https://gsp.lazada.com/gsp/helpcenter',
};

export const EXPORT_CANCEL_ORDER_PLATFORMS: General.PlatformUpperCase[] = [
  'SHOPEE',
  'LAZADA',
  'TIKTOK',
  'TIKTOK_US',
];
